// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__oZA0E","text":"SelectPayment_text__13FB4","title":"SelectPayment_title__hpFeX","btn":"SelectPayment_btn__2v4jZ"};